import { jsx } from '@emotion/react';
import * as React from 'react';
import { Fragment } from 'react';

import uuid from '@/utils/uuid';

import { getDuotoneFilter } from './functions/utils';
import IntrinsicElements = jsx.JSX.IntrinsicElements;

export interface DuotoneProps extends React.Attributes {
  tagName?: keyof IntrinsicElements;
  duotoneFilter?: string;
}

const Duotone: React.FC<DuotoneProps> = ({ tagName = 'div', duotoneFilter, ...props }) => {
  const id = uuid.v4('duotone');
  const filter = getDuotoneFilter(id, duotoneFilter?.split(',') ?? []);
  const TagName = tagName as React.ElementType;

  return (
    <>
      <TagName {...props} style={{ filter: `url(#${id})` }} />
      {filter}
    </>
  );
};

export default Duotone;
